export const FAMILY_PROFILE_KEYS = ['HouseholdSize', 'HasChildrenUnder18', 'ChildrenAges'];
export const PREFER_NOT_TO_ANSWER = 'prefer-not-to-answer';
export const HAS_CHILDREN_UNDER_18_YES = '30';

export const isNumericFamilyProfile = (key?: string): boolean => key === 'HouseholdSize' || key === 'ChildrenAges';

export const isValidFamilyProfileValue = (key: string, value?: string): boolean => {
  if (!isNumericFamilyProfile(key)) return true;
  if (value === PREFER_NOT_TO_ANSWER) return true;
  if (!value?.trim()) return false;
  const parts = key === 'HouseholdSize' ? [value.trim()] : value.split(',').map(part => part.trim());
  return parts.every(part => /^\d+$/.test(part) && Number.isSafeInteger(Number(part)) &&
    (key === 'HouseholdSize' ? Number(part) >= 1 && Number(part) <= 2147483647 : Number(part) <= 17));
};
